module.exports = __webpack_public_path__ + "static/media/promo-image-coins.5b2f9252.png";